import { useEffect, useState } from 'react';

function throttle(func, delay=200) {
    var lastCallTime = 0;
    return function () {
      var now = Date.now();
      if (now - lastCallTime >= delay) {
        func.apply(null, arguments);
        lastCallTime = now;
      }
    };
};

const useWindowSize = () => {
  const [width, setWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWidth(window.innerWidth);
  };

  // 使用节流函数处理resize事件
  const throttledHandleResize = throttle(handleResize, 100);

  useEffect(() => {
    window.addEventListener('resize', throttledHandleResize);
    return () => {
      window.removeEventListener('resize', throttledHandleResize);
    };
  }, []);

  return width;
};

export default useWindowSize;